import { useState } from "react";
import TextInput from "../../../common/TextInput";
import PhoneInput from "../../../common/PhoneInput";
import PartySection from "./PartySection";
import { EMAIL_REGEX } from "../../../utils/Constant";
import { phoneError as phoneErrorMsg } from "../../../utils/phone";
const emailErrorMsg = (value) =>
  value && !EMAIL_REGEX.test(value) ? "Enter a valid email address" : "";

export default function PartyDetailsStep({
  supplierForm,
  setSupplierForm,
  shippingForm,
  handleShippingChange,
  billingForm,
  setBillingForm,
  billingSameAsShipping,
  handleBillingSameToggle,
}) {
  const [touched, setTouched] = useState({});
  const markTouched = (field) => setTouched((t) => ({ ...t, [field]: true }));

  return (
    <div className="space-y-5">
      <PartySection title="Supplier Details">
        <TextInput
          label="Company Name"
          required
          value={supplierForm.name}
          onChange={(e) => setSupplierForm((f) => ({ ...f, name: e.target.value }))}
        />
        <TextInput
          label="Address"
          required
          value={supplierForm.address}
          onChange={(e) => setSupplierForm((f) => ({ ...f, address: e.target.value }))}
        />
        <div className="grid gap-3 sm:grid-cols-3">
          <TextInput
            label="Contact Person"
            required
            value={supplierForm.person}
            onChange={(e) => setSupplierForm((f) => ({ ...f, person: e.target.value }))}
          />
          <div>
            <PhoneInput
              label="Phone #"
              required
              value={supplierForm.contactNumber}
              onChange={(value) => setSupplierForm((f) => ({ ...f, contactNumber: value }))}
              onBlur={() => markTouched("supplierPhone")}
            />
            {touched.supplierPhone &&
              phoneErrorMsg(supplierForm.contactNumber) && (
                <p className="mt-1 px-0.5 text-[11px] text-red-500">
                  {phoneErrorMsg(supplierForm.contactNumber)}
                </p>
              )}
          </div>
          <div>
            <TextInput
              label="Email"
              required
              type="email"
              value={supplierForm.email}
              onChange={(e) => setSupplierForm((f) => ({ ...f, email: e.target.value }))}
              onBlur={() => markTouched("supplierEmail")}
            />
            {touched.supplierEmail && emailErrorMsg(supplierForm.email) && (
              <p className="mt-1 px-0.5 text-[11px] text-red-500">
                {emailErrorMsg(supplierForm.email)}
              </p>
            )}
          </div>
        </div>
        <div className="grid gap-3 sm:grid-cols-2">
          <TextInput
            label="Tax ID"
            required
            value={supplierForm.taxId}
            onChange={(e) => setSupplierForm((f) => ({ ...f, taxId: e.target.value }))}
          />
          <TextInput
            label="Quotation #"
            required
            value={supplierForm.quotation}
            onChange={(e) =>setSupplierForm((f) => ({ ...f, quotation: e.target.value }))}
          />
        </div>
      </PartySection>

      <PartySection title="Shipping Details">
        <TextInput
          label="Company Name"
          required
          value={shippingForm.name}
          onChange={(e) => handleShippingChange("name", e.target.value)}
        />
        <TextInput
          label="Address"
          required
          value={shippingForm.address}
          onChange={(e) => handleShippingChange("address", e.target.value)}
        />
        <div className="grid gap-3 sm:grid-cols-3">
          <TextInput
            label="Contact Person"
            required
            value={shippingForm.person}
            onChange={(e) => handleShippingChange("person", e.target.value)}
          />

          <div>
            <PhoneInput
              label="Phone #"
              required
              value={shippingForm.contactNumber}
              onChange={(value) => handleShippingChange("contactNumber", value)}
              onBlur={() => markTouched("shippingPhone")}
            />
            {touched.shippingPhone &&
              phoneErrorMsg(shippingForm.contactNumber) && (
                <p className="mt-1 px-0.5 text-[11px] text-red-500">
                  {phoneErrorMsg(shippingForm.contactNumber)}
                </p>
              )}
          </div>
          <div>
            <TextInput
              label="Email"
              required
              type="email"
              value={shippingForm.email}
              onChange={(e) => handleShippingChange("email", e.target.value)}
              onBlur={() => markTouched("shippingEmail")}
            />
            {touched.shippingEmail && emailErrorMsg(shippingForm.email) && (
              <p className="mt-1 px-0.5 text-[11px] text-red-500">
                {emailErrorMsg(shippingForm.email)}
              </p>
            )}
          </div>
        </div>
        <TextInput
          label="Tax ID"
          required
          value={shippingForm.taxId}
          onChange={(e) => handleShippingChange("taxId", e.target.value)}
        />
      </PartySection>

      <PartySection title="Billing Details">
        <label className="flex items-center gap-2 rounded-lg bg-slate-50 px-3 py-2.5 text-[13px] text-slate-700">
          <input
            type="checkbox"
            checked={billingSameAsShipping}
            onChange={(e) => handleBillingSameToggle(e.target.checked)}
            className="h-4 w-4 rounded border-slate-300 text-brand-600"
          />
          Use same address as shipping
        </label>
        {!billingSameAsShipping && (
          <>
            <TextInput
              label="Company Name"
              required
              value={billingForm.name}
              onChange={(e) => setBillingForm((f) => ({ ...f, name: e.target.value }))}
            />
            <TextInput
              label="Address"
              required
              value={billingForm.address}
              onChange={(e) =>setBillingForm((f) => ({ ...f, address: e.target.value }))}
            />
            <div className="grid gap-3 sm:grid-cols-3">
              <TextInput
                label="Contact Person"
                required
                value={billingForm.person}
                onChange={(e) => setBillingForm((f) => ({ ...f, person: e.target.value }))}
              />
              <div>
                <PhoneInput
                  label="Phone #"
                  required
                  value={billingForm.contactNumber}
                  onChange={(value) => setBillingForm((f) => ({ ...f, contactNumber: value }))}
                  onBlur={() => markTouched("billingPhone")}
                />
                {touched.billingPhone &&
                  phoneErrorMsg(billingForm.contactNumber) && (
                    <p className="mt-1 px-0.5 text-[11px] text-red-500">
                      {phoneErrorMsg(billingForm.contactNumber)}
                    </p>
                  )}
              </div>
              <div>
                <TextInput
                  label="Email"
                  required
                  type="email"
                  value={billingForm.email}
                  onChange={(e) => setBillingForm((f) => ({ ...f, email: e.target.value }))}
                  onBlur={() => markTouched("billingEmail")}
                />
                {touched.billingEmail && emailErrorMsg(billingForm.email) && (
                  <p className="mt-1 px-0.5 text-[11px] text-red-500">
                    {emailErrorMsg(billingForm.email)}
                  </p>
                )}
              </div>
            </div>
            <TextInput
              label="Tax ID"
              required
              value={billingForm.taxId}
              onChange={(e) => setBillingForm((f) => ({ ...f, taxId: e.target.value }))}
            />
          </>
        )}
      </PartySection>
    </div>
  );
}
